<template>
  <van-dialog
    v-model:show="show"
    :title="$t('提示')"
    :confirm-button-text="$t('已知曉')"
    confirm-button-color="#91D12E"
    :show-confirm-button="false"
  >
    <div class="content">
      <van-icon
        class="close-icon"
        name="cross"
        color="#9C9C9C"
        size="20px"
        @click="close"
      />
      {{ msg }}
    </div>
    <!-- footer -->
    <div slot="footer">
      <van-button
        class="confirm-btn"
        color="#91D12E"
        size="middle"
        @click="confirm"
      >
        {{ $t("已知曉") }}
      </van-button>
    </div>
  </van-dialog>
</template>

<script>
import { ref } from "vue";
export default {
  name: "DrugTipsDialog",
  setup() {
    const show = ref(false);
    const msg = ref("");
    return {
      show,
      msg,
    };
  },
  data() {
    return {
      callback: null
    };
  },
  methods: {
    showDrugTips(msg, callback) {
      this.show = true;
      this.msg = msg;
      this.callback = callback;
    },
    close() {
      this.show = false;
    },
    confirm() {
      this.show = false;
      if (typeof this.callback === 'function') {
        this.callback();
      }
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  font-size: 14px;
  color: #000;
  // line-height: 24px;
  // text-align: center;
  padding: 10px 24px;
  position: relative;
  .close-icon {
    position: absolute;
    right: 20px;
    top: -30px;
  }
}
.confirm-btn {
  border-radius: 10px;
  margin: 8px 24px 24px;
  display: block;
  width: calc(100% - 48px);
  height: 40px;
  line-height: 40px;
}
</style>
